// vuex 在页面刷新时会重置，先缓存在会话存储中
export default {
  // 设置用户信息
  SET_USER_INFO (state, data) {
    state.userInfo = data
    localStorage.setItem('userInfo', JSON.stringify(data))
  }
}
